import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const sendResetLink = createAsyncThunk(
  "forgetPassword/sendResetLink",
  async ({ token, newPassword, confirmPassword }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `https://social-media-dashboard-api.vercel.app/api/v1/reset-password?token=${token}`,
        { newPassword, confirmPassword } 
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



export const forgetPasswordSlice = createSlice({
  name: "forgetPassword",
  initialState: { status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendResetLink.pending, (state) => {
        state.status = "loading";
      })
      .addCase(sendResetLink.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(sendResetLink.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default forgetPasswordSlice.reducer;
